import { AlertType } from "./AlertType";

export class AlertModel {
  constructor(public type: AlertType, public message: string, public error?: Error) { }
}



// WEBPACK FOOTER //
// ./src/app/pillar/alerts/models/AlertModel.ts